import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Alert, Chips, Space, Typography } from '@zenlayer/zen-design';
import { pickDomAttrs } from '@zenlayer/zen-design/esm/_util/utils';
import t from '@zenlayer/zen-intl18';
import qs from 'query-string';
export var PricingType;
(function (PricingType) {
    PricingType["POSTPAID"] = "POSTPAID";
    PricingType["PREPAID"] = "PREPAID";
})(PricingType || (PricingType = {}));
const PricingList = (supportModal) => {
    const postpaid = supportModal.includes(PricingType.POSTPAID);
    const prepaid = supportModal.includes(PricingType.PREPAID);
    const list = [
        {
            name: t('qn40wlf3Zjad'),
            value: PricingType.POSTPAID,
            desc: t('7ofIoPyTTMhd'),
            show: postpaid, // TODO: 权限管理
        },
        {
            name: t('i3s5Z29qJQb4'),
            value: PricingType.PREPAID,
            desc: t('d5L57l7VoUPj'),
            show: prepaid,
        },
    ];
    const pricingList = list.filter((f) => f.show);
    return pricingList;
};
export const PricingDescCont = (_jsx(_Fragment, { children: _jsxs("div", { className: "pricingDescContWrap", children: [_jsx("div", { className: "subscriptionTitle", children: t('mH7iwiiGtNEh') }), _jsx("div", { className: "desc", children: t('ajDMhrn6UkyL') })] }) }));
export const PriceModal = function ({ onChange, hideHelp, className, supportModal, secondsBilling, ...restProps }) {
    const attrs = pickDomAttrs(restProps);
    const [defVal, setDefVal] = useState(supportModal[0]);
    const urlObj = qs.parse(location.search);
    const pricingList = PricingList(supportModal);
    useEffect(() => {
        let defValue = '';
        if (urlObj.chargeType) {
            const index = pricingList.findIndex((find) => find.value.toLocaleLowerCase() === urlObj.chargeType);
            if (index >= 0) {
                defValue = pricingList[index].value;
            }
        }
        else {
            defValue =
                pricingList.length > 0 ? pricingList[0].value : PricingType.PREPAID;
        }
        setDefVal(defValue);
    }, []);
    useEffect(() => {
        if (defVal) {
            onChange && onChange(defVal);
        }
    }, [defVal]);
    return (_jsx(Typography, { ...attrs.data, title: t('PJR0Y1LcI8eT'), className: className, help: !hideHelp
            ? {
                title: t('IXnvs0sIO3Ub'),
                content: (_jsxs(Space, { direction: "vertical", size: "lll", children: [supportModal.includes('PREPAID') && (_jsxs(Space, { direction: "vertical", children: [_jsx(Typography.Title, { size: "16-20", children: t('5i8NT7OKO8O1') }), _jsx("div", { children: t('IbIdtWesvj7b') }), _jsx(Alert, { type: "info", children: t('flfPlN4llMr9') })] })), supportModal.includes('POSTPAID') && (_jsxs(Space, { direction: "vertical", children: [_jsx(Typography.Title, { size: "16-20", children: t('FmdoSNjMrnMq') }), _jsx("div", { children: t('VPevWrDeT8ZS') })] }))] })),
            }
            : undefined, children: _jsxs("div", { style: { maxWidth: '1280px' }, children: [_jsx(Chips.Group, { size: "s", type: "filled", value: defVal, onChange: (val) => {
                        if (val) {
                            onChange && onChange(val);
                            setDefVal(val);
                        }
                    }, children: pricingList.map((item) => {
                        const { name, value } = item;
                        return (_jsx(Chips, { value: value, data: item, children: name }, value));
                    }) }), defVal === PricingType.POSTPAID && secondsBilling && (_jsx("div", { className: "mt-2", children: t('RFaDVQe7fn8j') }))] }) }));
};
